import { render, staticRenderFns } from "./DeviceTemplate.vue?vue&type=template&id=c21ae7da&scoped=true"
import script from "./DeviceTemplate.vue?vue&type=script&lang=js"
export * from "./DeviceTemplate.vue?vue&type=script&lang=js"
import style0 from "./DeviceTemplate.vue?vue&type=style&index=0&id=c21ae7da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21ae7da",
  null
  
)

export default component.exports